import { useContext } from "react";

import {
    userContext,
} from 'global/context/sub-contexts/userContext'

/*
This exposes user context via a hook

using this to migrate to the pattern that react-admin follows
https://github.com/marmelab/react-admin/blob/master/packages/ra-core/src/controller/record/useRecordContext.ts
https://github.com/marmelab/react-admin/blob/master/packages/ra-core/src/controller/record/RecordContext.tsx

usage:
import { useUserContext } from 'hooks/useUserContext'

const profile = useUserContext()

*/

export const useUserContext = () => {
    const context = useContext(userContext);

    return context.getProfile()
}